import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewEncapsulation } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { UiBadgeSize } from "@webapp/ui/badge/badge.models";

// Code is copied from ng-zorro's source since NzBadgeSupComponent is no longer exported in version 13.4.0
@Component({
  selector: "ui-badge-sup",
  exportAs: "uiBadgeSup",
  templateUrl: "./badge-sup.component.html",
  styleUrls: ["./badge-sup.component.less"],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-scroll-number",
    "[attr.title]": `nzTitle === null ? '' : nzTitle || nzCount`,
    "[attr.aria-label]": `a11yLabel || (nzCount ? nzCount + ' notifications' : '0 notifications')`,
    "[style]": `nzStyle`,
    "[style.right.px]": `nzOffset && nzOffset[0] ? -nzOffset[0] : null`,
    "[style.margin-top.px]": `nzOffset && nzOffset[1] ? nzOffset[1] : null`,
    "[style.padding-top.px]": `count > nzOverflowCount ? 0 : 3`,
    "[style.min-width]": "getWidth()",
    "[style.min-height]": "getHeight()",
    "[style.display]": "'flex'",
    "[style.justify-content]": "'center'",
    "[style.align-items]": "'center'",
    "[style.border-radius]": "'32px'",
    "[class.ant-badge-count]": `!nzDot`,
    "[class.ant-badge-count-sm]": `size === 'small'`,
    "[class.ant-badge-dot]": `nzDot`,
  },
})
export class UiBadgeSupComponent implements OnInit, OnChanges {
  @Input("uiOffset") public nzOffset?: [number, number];
  @Input("uiTitle") public nzTitle?: string | null | undefined;
  @Input("uiStyle") public nzStyle: { [key: string]: string } | null = null;
  @Input("uiDot") public nzDot = false;
  @Input("uiOverflowCount") public nzOverflowCount = 99;
  @Input("uiCount") public nzCount?: number | TemplateRef<NzSafeAny>;
  @Input("uiSize") public size: UiBadgeSize = "small";
  @Input() public a11yLabel: string;

  public count = 0;
  public countDisplay = "";

  public ngOnInit(): void {
    this.count = Number(this.nzCount);
    this.updateCountDisplay();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { nzCount, nzOverflowCount } = changes;
    if (nzCount && typeof nzCount.currentValue === "number") {
      this.count = Math.max(0, nzCount.currentValue);
      if (nzOverflowCount && this.count > nzOverflowCount.currentValue) {
        this.count = nzOverflowCount.currentValue;
      }
      this.updateCountDisplay();
    }
    if (nzOverflowCount) {
      this.updateCountDisplay();
    }
  }

  private updateCountDisplay(): void {
    if (this.nzOverflowCount && this.count >= this.nzOverflowCount) {
      this.countDisplay = "+";
    } else {
      this.countDisplay = this.count.toString();
    }
  }

  private readonly sizeToWidthHeight = {
    small: "16px",
    medium: "24px",
    large: "32px",
  };

  public getWidth(): string {
    return this.sizeToWidthHeight[this.size] || this.sizeToWidthHeight.small;
  }

  public getHeight(): string {
    return this.sizeToWidthHeight[this.size] || this.sizeToWidthHeight.small;
  }
}
